import React from 'react'
import moment from 'moment'
import i18next from 'i18next'
import classNames from 'classnames'

import listingStyles from './styles/listing.scss'

export default class WopiListProfile extends React.Component {
  render() {
    const {
      questionnaire,
      isSelected,
      isDeleted,
      onToggleSelection,
      hideDuration,
      children
    } = this.props

    const isAboutToExpire = moment(questionnaire.finishedAt).isBefore(
      moment().subtract(90 - 7, 'days'),
      'day'
    )

    const classes = {
      [listingStyles.selected]: isSelected,
      [listingStyles.aboutToExpire]: isAboutToExpire,
      [listingStyles.deleted]: isDeleted
    }

    return (
      <tr key={questionnaire.uuid} className={classNames(classes)}>
        {onToggleSelection && (
          <td className={listingStyles.select} onClick={onToggleSelection}>
            <input type="checkbox" checked={!!isSelected} />
          </td>
        )}

        <td style={{ width: 140 }}>{moment(questionnaire.finishedAt).format('dd l')}</td>

        <td>
          {questionnaire.personalInformation && (
            <span>
              {questionnaire.personalInformation.givenName}{' '}
              {questionnaire.personalInformation.familyName}
            </span>
          )}

          <br />
          <small>{questionnaire.invitation.email}</small>

          {isAboutToExpire && (
            <div className={listingStyles.aboutToExpireNotification}>
              {i18next.t('questionnaire_is_about_to_expire')}
            </div>
          )}
        </td>

        <td>
          {questionnaire.invitation.organisation}
          <br />
          <small>{questionnaire.invitation.role}</small>
        </td>

        {!hideDuration && (
          <td>
            {Math.round(
              moment.duration(questionnaire.finishedAt - questionnaire.startedAt).asMinutes()
            )}
            <small>&nbsp;{i18next.t('min')}</small>
          </td>
        )}

        {children && <td>{children}</td>}
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiListProfile.js